var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#1CCD78",
    stroke: "#1CCD78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 22.2858C12.2282 22.2798 11.8907 22.1965 11.584 22.0422C11.2773 21.8879 11.0094 21.6664 10.8 21.3944L8.28573 18.5486C8.18506 18.4358 8.1078 18.304 8.05843 18.161C8.00906 18.018 7.98857 17.8667 7.99814 17.7157C8.00771 17.5648 8.04715 17.4172 8.11417 17.2816C8.18119 17.146 8.27447 17.0251 8.38859 16.9258C8.61749 16.7274 8.9158 16.628 9.21795 16.6494C9.52011 16.6708 9.8014 16.8114 10 17.0401L12.3543 19.7029C12.3772 19.7359 12.4081 19.7626 12.444 19.7806C12.48 19.7986 12.5199 19.8072 12.56 19.8058C12.5989 19.8067 12.6376 19.799 12.6732 19.7832C12.7087 19.7674 12.7404 19.7439 12.7657 19.7144L22.0343 10.0686C22.2488 9.87578 22.5282 9.77113 22.8166 9.7757C23.105 9.78027 23.381 9.89371 23.5893 10.0933C23.7975 10.2929 23.9226 10.5638 23.9394 10.8517C23.9563 11.1397 23.8636 11.4233 23.68 11.6458L14.3086 21.5086C14.0949 21.759 13.8281 21.9587 13.5276 22.0931C13.2272 22.2275 12.9005 22.2933 12.5714 22.2858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickV2);
export default __webpack_public_path__ + "static/media/green-tick-v2.8f5302b47f5df256a0bfa0b42c3e8a0b.svg";
export { ForwardRef as ReactComponent };